import { Link } from "react-router-dom";
import { company } from "@/data/company";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-gavito-dark text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gavito-green rounded-xl flex items-center justify-center">
                <span className="font-heading font-black text-white text-xl leading-none">G</span>
              </div>
              <span className="font-heading font-extrabold text-xl">GAVITO technic</span>
            </div>
            <p className="font-heading font-extrabold text-3xl md:text-4xl tracking-tight leading-tight max-w-md">
              Vzděláváme úplně jinak, než jste zvyklí.
            </p>
            <Link
              to="/kontakt"
              className="inline-block mt-8 bg-gavito-green text-white font-semibold px-8 py-3.5 rounded-full hover:bg-white hover:text-gavito-navy transition-colors"
            >
              Domluvit kurz
            </Link>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <p className="text-xs uppercase tracking-[0.2em] text-gavito-green font-bold mb-5">Navigace</p>
            <ul className="space-y-3 text-white/70">
              <li><Link to="/" className="hover:text-white transition-colors">Úvod</Link></li>
              <li><Link to="/o-nas" className="hover:text-white transition-colors">Proč my</Link></li>
              <li><Link to="/kurzy" className="hover:text-white transition-colors">Kurzy</Link></li>
              <li><Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link></li>
            </ul>
            <p className="text-xs uppercase tracking-[0.2em] text-gavito-green font-bold mb-4 mt-8">Dokumenty</p>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><Link to="/gdpr" className="hover:text-white transition-colors">Ochrana osobních údajů</Link></li>
              <li><Link to="/obchodni-podminky" className="hover:text-white transition-colors">Obchodní podmínky</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-gavito-green font-bold mb-5">Kontakt</p>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href={`tel:${company.phone}`} className="hover:text-white transition-colors">{company.phone}</a></li>
              <li><a href={`mailto:${company.email}`} className="hover:text-white transition-colors">{company.email}</a></li>
              <li>{company.address}</li>
              <li className="pt-2">IČO: {company.ico}</li>
              <li>DIČ: {company.dic}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col gap-3 text-sm text-white/50">
          <p className="text-white/40">{company.rejstrik}</p>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
            <p>© {new Date().getFullYear()} {company.name}</p>
            <p className="text-gavito-green font-semibold">Vzděláváme s láskou.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
